function ReportAgent() {
    "use strict";

    this.__type = 'ReportAgent:www.veritracks.com';
    this.Id = -1;
    this.Version = 0;

    this.OrganizationId = -1;
    this.UserId = -1;
    this.ReportGroupId = -1;
    this.SchemaName = '';
}
if (typeof exports !== 'undefined') {
    module.exports = ReportAgent;
}